import React from 'react';
import { IonIcon } from '@ionic/react';
import * as Ionicons from 'ionicons/icons';

import { Icon as IconDto } from '../../types/dtos/icon.dto';
import { IconSource } from '../../types/icon-source';

interface IconProps extends Omit<React.HTMLAttributes<HTMLElement>, 'children'> {
  icon: IconDto;
  size?: 'small' | 'large';
  /**
   * Optional color (only applies to ionicons).
   */
  color?: string;
}

/**
 * Renders an icon agnostic of its source (Ionicons or external URL).
 */
export const Icon: React.FC<IconProps> = ({ icon, size, color, ...rest }) => {
  if (!icon) {
    return null;
  }

  if (icon.iconSource === IconSource.Ionicons) {
    const { ioniconId } = icon;
    return <IonIcon icon={Ionicons[ioniconId]} size={size} color={color} {...rest} />;
  }

  if (icon.iconSource === IconSource.Url) {
    const { iconUrl } = icon;

    // Map 'small' and 'large' to pixel values for URL icons
    let resolvedSize: string = size ?? 'small';
    if (size === 'small') {
      resolvedSize = '24px';
    } else if (size === 'large') {
      resolvedSize = '32px';
    }

    const style = {
      width: resolvedSize,
      height: resolvedSize,
      ...rest.style,
    } as React.CSSProperties;

    return <img src={iconUrl} style={style} alt={rest['aria-label'] as string | undefined} {...rest} />;
  }

  // Should never reach here if all enum values are handled.
  return null;
};

export default Icon;
